import { render, staticRenderFns } from "./Ligar.vue?vue&type=template&id=3fa4c6d8&scoped=true&"
import script from "./Ligar.vue?vue&type=script&lang=js&"
export * from "./Ligar.vue?vue&type=script&lang=js&"
import style0 from "./Ligar.vue?vue&type=style&index=0&id=3fa4c6d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa4c6d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCol,VSpacer,VToolbar})
